import React, { useState } from "react";
import Image from "components/image";
import Collapsible from "react-collapsible";
import RichText from "components/rich-text";
import TextArea from "components/text-area";
import clsx from "clsx/lite";
import { formatTitle } from "helpers/format-title";

const ContentAccordion = ({ data }) => {
	const { content, accordion } = data;

	const [isActivePanel, setActivePanel] = useState({});
	const togglePanel = (index) => {
		setActivePanel((prevState) => ({ ...prevState, [index]: !prevState[index] }));
	};
	return (
		<div className={clsx(content ? "w-11/12" : "md:w-10/12 w-11/12", "md:lg-4/5 m-auto hd-screen-max-width")}>
			<h2 className="text-center hidden md:block">{formatTitle(data.title)}</h2>
			<div className="flex gap-5 md:gap-10 mt-10 flex-col md:flex-row box-border">
				{content &&
					<div className="md:w-[45%]">
						{content[0]?._type === "richText" ?
							<RichText value={content[0]} /> :
							<Image image={content[0]?.asset} alt={content[0]?.alt} />}
					</div>}
				<div className={`${!content ? "md:w-[100%]" : "md:w-[55%]"}`}>
					<h2 className="text-center block md:hidden my-3">{formatTitle(data.title)}</h2>
					{accordion.map((c, i) => {
						const isOpen = isActivePanel[i];
						return (
							<Collapsible
								className="border-t-[1px] border-t-[#E7EFEF]"
								openedClassName="border-t-[1px] border-t-[#E7EFEF]"
								key={c._key}
								transitionTime="200"
								triggerTagName="div"
								triggerElementProps={{ id: c._key }}
								contentElementId={c._key}
								onOpening={() => togglePanel(i)}
								onClosing={() => togglePanel(i)}
								trigger={[
									<span className="py-7.5" key={c.title}>
										{formatTitle(c.title)}
									</span>,
									<div key={c._key}
										className={clsx(
											"plus-minus-toggle flex-shrink-0", isOpen && "before:rotate-90 after:rotate-180"
										)}>
									</div>,
								]}
							>
								<div className="pb-7.5 text-[#676767]">
									<RichText value={c.content} />
								</div>
							</Collapsible>
						);
					})}
					{data?.text?.data && <TextArea customClass={"py-5"} value={data?.text?.data} />}
				</div>
			</div>
		</div>
	);
};

export default ContentAccordion;
